import { GoogleMaterialIcon } from '../ui/GoogleMaterialIcon';
import React, { Fragment, useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { TrackNowButton, TrackNowTextField } from '../ui';
import Divider from '@mui/material/Divider';
import AuthContext from '../../context/auth/AuthContext';
import FilingMasterContext from '../../context/filing-master/FilingMasterContext';
import CustomDialog from '../common/CustomDialog';
import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  Link,
  ListItemButton,
  Card,
  CardActions,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import type { DraftFilingMaster } from '../../types/FilingMaster';
import axios from 'axios';
import FileDownload from 'js-file-download';
import Loader from '../common/Loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from "@mui/icons-material/Close";
import HistoryChangeDetails from '../common/HistoryChangeDetails';

type Anchor = 'top' | 'left' | 'bottom' | 'right';
const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

export default function ApproveFilingMaster(props: {
  dockAt?: 'top' | 'left' | 'bottom' | 'right';
  show?: boolean;
  handleClose: () => void;
  draft?: DraftFilingMaster;
  drafts?: DraftFilingMaster[];
  updateSelectedWorkflow?: (workflow: any) => void;
}) {
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    approveBulkFilingMasterWorkflow,
    rejectBulkFilingMasterWorkflow,
    getApproverList,
  } = filingMasterContext;
  const authContext = useContext(AuthContext);
  const {
    roleType,
    authUser,
    userRoles,
    toLocalDateTime,
    getCustomerNotifications,
    getFilingNotifications,
    getCustomerNotificationsWorkFlow,
    getAllNotificationCount,
    token,
    setNotificationCount,
  } = authContext;
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [alertMessage, setAlertMessage] = useState('');
  const [filingsNames, setFilingsNames] = useState<(string | undefined)[] | []>(
    []
  );
  const [approvalComment, setApprovalComment] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [approvers, setApprovers] = useState<any[]>([]);
  // const [selectedApprover, setSelectedApprover] = useState<string>("");
  const [attachmentList, setAttachmentList] = useState<any>();
  const [showApproverAlert, setShowApproverAlert] = useState(false);
  const [customerNotificationCount, setCustomerNotificationCount] =
    React.useState(0);
  const [filingNotificationCount, setFilingNotificationCount] =
    React.useState(0);
  const [customerNotificationsWorkFlow, setCustomerNotificationsWorkFlow] =
    React.useState(0);

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        // console.log(`Drawer Mouse Key Event...`);
        // if (
        //   event.type === "keydown" &&
        //   ((event as React.KeyboardEvent).key === "Tab" ||
        //     (event as React.KeyboardEvent).key === "Shift")
        // ) {
        //   return;
        // }
        // console.log(`Toogle Drawer: DockAt:${anchor}, Show: ${open}`);
        // setState({ ...state, [anchor]: open });
        // if (!open) props.handleClose();
      };
  const closeAlert = () => {
    setShowAlert(false);
    // navigate("/filing-master-approval-list");
  };

  const listApprovers = async () => {
    try {
      const { drafts } = props;
      if (!getApproverList || !drafts || drafts.length === 0) {
        return;
      }
      const data = await getApproverList();
      // console.log("Unfiltered Approvers", data);
      let filteredApprovers = [];
      if (drafts[0].juristiction === 'State') {
        filteredApprovers = data.filter((approver: any) => {
          // const stateInfo = states.find(
          //   (i) => i.code === draft.stateInfo
          // )?.state;
          return (
            approver.juristiction === drafts[0].juristiction &&
            approver.state === drafts[0].stateInfo &&
            approver.customerId === null
          );
        });
      } else {
        filteredApprovers = data.filter((approver: any) => {
          return (
            approver.juristiction === drafts[0].juristiction &&
            approver.customerId === null
          );
        });
      }
      // console.log('Filtered Approvers', filteredApprovers);
      setApprovers(filteredApprovers);
    } catch (err) {
      console.error(err);
    }
  };

  const getFilename = function (str: string) {
    // console.log('getFilename', str);
    return str ? str.substring(str.lastIndexOf('/') + 1, str.length) : '';
  };

  const downloadFile = (
    attachmentPath: any,
    attachmentId: any,
    draftId: any
  ) => {
    if (props.drafts && props.drafts.length > 0) {
      let filingId = props?.drafts.filter((ele) => ele.draftId === draftId)[0]
        .filingId;
      axios({
        url: `${API_BASE_URL}/Application/DownloadAttachment?AttachmentId=${attachmentId}&FilingId=${filingId}&DraftId=${draftId}`,
        method: 'POST',
        responseType: 'blob', // Important
      }).then((response) => {
        FileDownload(response.data, attachmentPath);
      });
    }
  };

  const getAttachments = async () => {
    // console.log('getAttachments', props?.draft?.draftId);
    if (props.drafts) {
      for (const draft of props.drafts) {
        const draftId: number = draft.draftId ? draft.draftId : 0;
        try {
          const res = await axios.get(
            `${API_BASE_URL}/FilingMaster/FilingMasterDraftAttachments/${draftId}`
          );
          // console.log('getAttachments res', res.data.data);
          if (res.data) {
            setAttachmentList((prevState: any) => ({
              ...prevState,
              [draftId]: res.data.data,
            }));
          }
        } catch (error) {
          // Handle the error appropriately
          console.error(error);
        }
      }
    }
    // console.log('ATTS:', attachmentList);
  };

  useEffect(() => {
    if (showApproverAlert) {
      const timer = setTimeout(() => {
        setShowApproverAlert(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showApproverAlert]);

  useEffect(() => {
    if (
      typeof props.dockAt !== 'undefined' &&
      typeof props.show !== 'undefined'
    ) {
      if (props.show) setState({ ...state, [props.dockAt]: props.show });
      getAttachments();
    }
    listApprovers();
    //eslint-disable-next-line
  }, [props.show]);

  useEffect(() => {
    // if(props.draft && props.draft.createDate!==null)
    //eslint-disable-next-line
  }, [props.draft]);

  const ListElement = (item: any, index: any) => {
    // console.log('ListElement', item, index);
    const visibleChanges = (item.changedData || []).filter(
      (ele: any) =>
        ![
          'filingDescription',
          'dueDayofFrequency',
          'jsidept',
          'jsicontactEmail',
        ].some((value) => value.includes(ele.field))
    );
    return (
      <div className='tn-history-entry' key={index}>
        <ListItem disablePadding>
          <ListItemText
            primary={
              item && item.process && item.process !== null ? item.process : ''
            }
          />
        </ListItem>
        {visibleChanges.length > 0 && (
          <HistoryChangeDetails changeCount={visibleChanges.length}>
            <TableContainer>
              <Table
                sx={{ minWidth: 250, border: '1px solid black' }}
                size='small'
                aria-label='a dense table'
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Field</TableCell>
                    <TableCell>Old value</TableCell>
                    <TableCell>New value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visibleChanges.map((ele: any) =>
                    ele.field === 'Attachments' ? (
                      <TableRow>
                        <TableCell>{ele.field}</TableCell>
                        <TableCell>
                          {ele.old.map((attach: any) => (
                            <ListItem disablePadding>
                              <Link>
                                <GoogleMaterialIcon name="attach_file" />
                              </Link>
                              <ListItemButton
                                onClick={() =>
                                  downloadFile(
                                    attach.attachmentPath,
                                    attach.attachmentID,
                                    ele.draftId
                                  )
                                }
                              >
                                <ListItemText primary={attach.attachmentPath} />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </TableCell>
                        <TableCell>
                          {ele.new.map((attach: any) => (
                            <ListItem disablePadding>
                              <Link>
                                <GoogleMaterialIcon name="attach_file" />
                              </Link>
                              <ListItemButton
                                onClick={() =>
                                  downloadFile(
                                    attach.attachmentPath,
                                    attach.attachmentID,
                                    ele.draftId
                                  )
                                }
                              >
                                <ListItemText primary={attach.attachmentPath} />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </TableCell>
                      </TableRow>
                    ) : ele.field === 'Due Date' ? (
                      <TableRow>
                        <TableCell>{ele.field}</TableCell>
                        <TableCell>
                          {ele.old.map((date: any) => (
                            <p>{date}</p>
                          ))}
                        </TableCell>
                        <TableCell>
                          {ele.new.map((date: any) => (
                            <p>{date}</p>
                          ))}
                        </TableCell>
                      </TableRow>
                    ) : (
                      <TableRow>
                        <TableCell>{ele.field}</TableCell>
                        <TableCell>{String(ele.old)}</TableCell>
                        <TableCell>{String(ele.new)}</TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </HistoryChangeDetails>
        )}
        <Stack className='tn-approval-kv-row' direction='row'>
          <ListItem className='tn-approval-kv-key' disablePadding>Approved Status</ListItem>
          <ListItem className='tn-approval-kv-value'>{item.responseStatus}</ListItem>
        </Stack>
      </div>
    );
  };

  useEffect(() => {
    if (
      typeof props.dockAt !== 'undefined' &&
      typeof props.show !== 'undefined'
    ) {
      setState({ ...state, [props.dockAt]: props.show });
    }
    setApprovalComment((old) => '');
    // listApprovers()
    //eslint-disable-next-line
  }, []);
  const toLocalTime = (date: Date): string => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat('dd-MMM-yyyy hh:mm:ss'),
        'dd-MMM-yyyy hh:mm:ss',
        { zone: 'UTC' }
      )
        .toLocal()
        .toFormat('dd-MMM-yyyy hh:mm:ss');
      return _date;
    } else return '';
  };

  const getUserName = (userId: any) => {
    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]
        ?.userName
      : '';
    return user;
  };

  const list = (anchor: Anchor) => (
    <Grid container>
      <Stack
        sx={{
          width: anchor === 'top' || anchor === 'bottom' ? 'auto' : '20vw',
          minWidth: '35vw',
          display: 'flex',
          alignContent: 'center',
        }}
        role='presentation'
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <Card className='tn-approval-drawer-card'>
          <CardContent>
            <Stack
              direction='row'
              justifyContent='space-between'
            >
              <Typography
                className='tn-drawer-title'
                gutterBottom
                variant='h5'
                component='div'
              >
                Approval
              </Typography>
              <IconButton>
                <CloseIcon onClick={() => handleClose(anchor)} />
              </IconButton>
            </Stack>
          </CardContent>

          <Box sx={{ mx: 2 }}>
            <Typography
              className='tn-section-title'
              gutterBottom
              variant='h5'
              component='div'
            >
              Approve Workflow
            </Typography>

            <List>
              {props.drafts &&
                props.drafts.map((item: any, index: number) => (
                  <Fragment key={index}>
                    {index !== 0 && <Divider />}
                    <Stack
                      className='tn-approval-meta-row'
                      direction='row'
                      justifyContent='space-between'
                    >
                      <ListItem
                        className='tn-approval-meta-user'
                        disablePadding
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {getUserName(item.createUser)}
                      </ListItem>
                      <ListItem className='tn-approval-meta-time'>
                        <ListItemText
                          secondary={
                            item &&
                            item.createDate &&
                            toLocalDateTime &&
                            `${toLocalDateTime(item.createDate)}`
                          }
                        />
                      </ListItem>
                    </Stack>
                    <Stack className='tn-approval-kv-row' direction='row'>
                      <ListItem className='tn-approval-kv-key' disablePadding>Filing Master Draft</ListItem>
                      <ListItem className='tn-approval-kv-value'>
                        {item.filingName}
                      </ListItem>
                    </Stack>
                    <Stack className='tn-approval-kv-row' direction='row'>
                      <ListItem className='tn-approval-kv-key' disablePadding>Submission Type</ListItem>
                      <ListItem className='tn-approval-kv-value'>
                        {item.businessOperation?.toUpperCase()}
                      </ListItem>
                    </Stack>
                    <Stack className='tn-approval-kv-row' direction='row'>
                      <ListItem className='tn-approval-kv-key' disablePadding>Current Approver</ListItem>
                      <ListItem className='tn-approval-kv-value'>
                        {item.approverName}
                      </ListItem>
                    </Stack>
                    {item.modified &&
                      item.modified
                        .slice()
                        .reverse()
                        .map((item: any, index: any) =>
                          ListElement(item, index)
                        )}
                  </Fragment>
                ))}
            </List>
            <TrackNowTextField
              id='notes'
              name='notes'
              multiline
              fullWidth
              minRows={3}
              placeholder='Notes'
              value={approvalComment}
              onChange={onCommentChange}
              sx={{ marginTop: 1 }}
            />
          </Box>
          <CardActions
            sx={{
              mt: '3rem',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: 1
            }}
          >
            <TrackNowButton
              variant="tertiary"
              onClick={() => handleClose(anchor)}
            >
              Cancel
            </TrackNowButton>
            <TrackNowButton
              variant="secondary"
              onClick={() => handleCancel(anchor, false)}
            >
              Reject
            </TrackNowButton>
            <TrackNowButton
              variant="primary"
              onClick={() => handleOk(anchor, true)}
            >
              Approve
            </TrackNowButton>
          </CardActions>
        </Card>
      </Stack>
    </Grid>
  );

  const onCommentChange = async (e: React.ChangeEvent<any>) => {
    setApprovalComment((old) => e.target.value);
  };

  const fetchNotificationCount = async () => {
    if (getAllNotificationCount) {
      try {
        if (token) {
          const res = await getAllNotificationCount(token, authUser?.userId);
          console.log('fetchNotifications', res);
          if (setNotificationCount) {
            setNotificationCount(res.totalCount);
          }
        }
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const handleOk = async (anchor: Anchor, approvalStatus?: boolean) => {
    try {
      if (props.drafts) {
        setIsLoading(true);
        const bulkPayload = props.drafts.map((draft) => {
          return {
            notes: approvalComment,
            role: roleType?.includes('Admin') ? 'Admin' : authUser?.roleName,
            userid: authUser?.userId + '',
            workFlowId: draft?.workflowId,
            draftId: draft?.draftId,
          };
        });

        if (approveBulkFilingMasterWorkflow) {

          const res = await approveBulkFilingMasterWorkflow(bulkPayload);
          if (res) {
            if (props.drafts && Array.isArray(props.drafts)) {
              setFilingsNames(props.drafts.map((item) => item.filingName));
            }
            if (res.errorMessage) {
              setAlertMessage(res.errorMessage);
            } else {
              setAlertMessage('Successfully approved the workflow(s) for ');
            }
            setShowAlert(true);
            setApprovalComment(() => '');
            props.updateSelectedWorkflow &&
              props.updateSelectedWorkflow(undefined);
            await fetchNotificationCount();
            setIsLoading(false);
            setState({ ...state, [anchor]: false });
            props.handleClose();
            return;
          }
        }
      }
    } catch (error) {
      if (props.drafts && Array.isArray(props.drafts)) {
        setFilingsNames(props.drafts.map((item) => item.filingName));
      }
      setAlertMessage('Unexpected Error occured during Workflow approval for');
      setShowAlert(true);
      setApprovalComment((old) => '');
    }
    setIsLoading(false);
  };

  const handleClose = async (anchor: Anchor) => {
    setState({ ...state, [anchor]: false });
    props.handleClose();
    setApprovers([]);
    setApprovalComment((old) => '');
  };

  const handleCancel = async (anchor: Anchor, approvalStatus?: boolean) => {
    try {
      if (props.drafts) {
        setIsLoading(true)
        const bulkPayload = props.drafts.map((draft) => {
          return {
            notes: approvalComment,
            role: roleType?.includes('Admin') ? 'Admin' : authUser?.roleName,
            userid: authUser?.userId + '',
            workFlowId: draft?.workflowId,
            draftId: draft?.draftId,
          };
        });
        if (rejectBulkFilingMasterWorkflow) {
          const res = await rejectBulkFilingMasterWorkflow(bulkPayload);
          if (res) {
            if (props.drafts && Array.isArray(props.drafts)) {
              setFilingsNames(props.drafts.map((item) => item.filingName));
            }
            if (res.errorMessage) {
              setAlertMessage(res.errorMessage);
            } else {
              setAlertMessage(`Workflow(s) have been rejected for `);
            }

            setShowAlert(true);
            setApprovalComment((old) => '');
            props.updateSelectedWorkflow &&
              props.updateSelectedWorkflow(undefined);
            await fetchNotificationCount();
            setIsLoading(false);
            setState({ ...state, [anchor]: false });
            props.handleClose();
            return;
          }
        }
      }
    } catch (error) {
      setAlertMessage('Unexpected Error occured during Workflow rejection');
      setShowAlert(true);
      setApprovalComment((old) => '');
    }
  };

  useEffect(() => {
    if (authUser && authUser?.userId) {
      //  fetchNotificationCount()
    };
  }, [authUser]);

  return (
    <div>
      <CustomDialog
        header='Info'
        visible={showAlert}
        onHide={() => closeAlert()}
      >
        {alertMessage}
        {filingsNames.length > 0 && (
          <ul>
            {Array.from(new Set(filingsNames)).map((name, index) => (
              <li key={index}>
                <strong>{name}</strong>
              </li>
            ))}
          </ul>
        )}
      </CustomDialog>
      {typeof props.dockAt !== 'undefined' && (
        <React.Fragment>
          <Drawer
            anchor={props.dockAt}
            open={state[props.dockAt]}
            onClose={toggleDrawer(props.dockAt, false)}
          >
            {list(props.dockAt)}
          </Drawer>
          {isLoading && (
            <Loader />
          )}
        </React.Fragment>
      )}
    </div>
  );
}
